<template>
  <sh-button
    :[btnLinkKey]="href"
    :naked="!isButton"
    :outline="setOutline"
    :size="size"
    :color="setColor"
    :target="target"
  >
    {{ text }}
  </sh-button>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CTA from '~/constants/appearance'
import { getButtonType } from '~/helpers/get-button-type'
import get from '~/helpers/get'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'CTA',
  props: {
    ctaFields: {
      type: Object,
      default: () => ({})
    },
    size: {
      type: String,
      default: 'medium'
    },
    ctaAppearance: {
      type: String,
      default: CTA.LINK
    },
    customStyles: {
      type: Object
    },
    ctaColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme']),
    color () {
      return this.ctaColor ? this.ctaColor.split(' ')[0] : ''
    },
    isTransparent () {
      return !!(this.ctaColor && this.ctaColor.split(' ')[1] === 'outlined')
    },
    text () {
      return get(this.ctaFields, 'text')
    },
    href () {
      return get(this.ctaFields, 'href')
    },
    isButton () {
      return this.ctaAppearance === CTA.BUTTON
    },
    target () {
      return get(this.ctaFields, 'target')
    },
    isOutline () {
      return this.isTransparent && this.isButton
    },
    setColor () {
      if (this.isDarkTheme && this.$device.isMobile) return CTA.SECONDARY
      if (!this.isDarkTheme && this.$device.isMobile) return CTA.PRIMARY
      return this.color
    },
    setOutline () {
      if (this.isButton) {
        if (this.isOutline) return true
        if (this.$device.isMobile) {
          if (!this.isDarkTheme && this.color === CTA.SECONDARY) return true
          if (this.isDarkTheme && this.color === CTA.PRIMARY) return true
        }
      }
      return false
    },
    btnLinkKey () {
      if (!this.ctaFields) return ''

      return getButtonType(this.href)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
